import { GetStaticPaths, GetStaticProps } from 'next'
import { ReactElement } from 'react'

import { dehydrate, QueryClient } from 'react-query'

import { getAllStaticPages } from 'app/services/Api/staticPage'
import { staticPageConfig } from 'app/services/Query/static-pages/static-pages.query'
import { NextPageExtended } from 'app/types/interfaces/nextjs'

import MainLayout from '~/components/layouts/MainLayout/MainLayout'
import StaticPageTrianglesContainer from '~/components/layouts/StaticPageTrianglesContainer'
import StaticPageView from '~/views/StaticPageView'

const StaticPage: NextPageExtended = () => {
  return (
    <StaticPageTrianglesContainer>
      <StaticPageView />
    </StaticPageTrianglesContainer>
  )
}

StaticPage.getLayout = (page: ReactElement) => <MainLayout>{page}</MainLayout>

export const getStaticPaths: GetStaticPaths = async () => {
  const posts = await getAllStaticPages()

  const paths = posts.reduce(
    (acc, path) =>
      acc.concat(
        path?.static_pages.map((item) => ({
          params: {
            slug: item?.slug
          }
        }))
      ),
    [] as { params: { slug?: string } }[]
  )

  return { paths, fallback: false }
}

export const getStaticProps: GetStaticProps = async (context) => {
  const slug = context.params?.slug as string

  try {
    const queryClient = new QueryClient()

    await queryClient.prefetchQuery(
      staticPageConfig.getStaticPage.key(slug),
      staticPageConfig.getStaticPage.request
    )

    return {
      props: { dehydratedState: dehydrate(queryClient) }
    }
  } catch (error) {
    return { notFound: true }
  }
}

export default StaticPage
